import { api } from "./api";

let cache = null;
export let appSettings = null;

export function getAppSettings(fresh = false) {
  if (!cache || fresh) {
    cache = api.get("/app/settings").then(({ data }) => { appSettings = data; return data; })
      .catch((e) => { cache = null; throw e; });
  }
  return cache;
}
